module.exports = __webpack_public_path__ + "img/Frame118.759eebb1.png";